angular.module('app.controllers').controller('MainAsideCtrl', function ($rootScope, $timeout, $translate) {
    const vm = this;

    $rootScope.$on('$stateChangeSuccess', () => {
        $timeout(() => {
            if (!$rootScope.miniSidebarActive) {
                // activate current section
                $('#sidebar_main').find('.current_section:not(.act_section ) > a').trigger('click');
            } else {
                // add tooltips to mini sidebar
                const tooltip_elem = $('#sidebar_main').find('.menu_tooltip');
                tooltip_elem.each(() => {
                    const element = $(this);
                    element.attr('title', element.find('.menu_title').text());
                    UIkit.tooltip(element, {});
                });
            }
        }, 500);
    });

    // language switcher
    vm.langSwitcherModel = 'pl';
    const langData = (vm.langSwitcherOptions = [
        { id: 1, title: 'English', value: 'gb' },
        { id: 7, title: 'German', value: 'de' },
        { id: 8, title: 'Polish', value: 'pl' },
    ]);
    vm.langSwitcherConfig = {
        maxItems: 1,
        render: {
            option(langData, escape) {
                return `<div class="option"><i class="item-icon flag-${escape(langData.value).toUpperCase()}"></i><span>${escape(langData.title)}</span></div>`;
            },
            item(langData, escape) {
                return `<div class="item"><i class="item-icon flag-${escape(langData.value).toUpperCase()}"></i></div>`;
            },
        },
        valueField: 'value',
        labelField: 'title',
        searchField: 'title',
        create: false,
        onInitialize(selectize) {
            $('#lang_switcher').next().children('.selectize-input').find('input').attr('readonly', true);
        },
    };

    // menu entries
    vm.sections = [
        {
            id: 0,
            title: $translate.instant('dashboard.calendars'),
            icon: 'event',
            allow: 'true',
            submenu: [
                {
                    link: 'restricted.dashboard_main',
                    title: $translate.instant('dashboard.main'),
                    allow: 'true',
                },
                {
                    link: 'restricted.dashboard_tasks',
                    title: $translate.instant('dashboard.tasks'),
                    allow: 'dashboard_tasks__read | dashboard_tasks__read_all',
                },
                {
                    link: 'restricted.dashboard_measurement',
                    title: $translate.instant('dashboard.measurement'),
                    allow: 'dashboard_measurement__read | dashboard_measurement__read_all',
                },
                {
                    link: 'restricted.dashboard_installation',
                    title: $translate.instant('dashboard.installation'),
                    allow: 'dashboard_installation__read | dashboard_installation__read_all',
                },
                {
                    link: 'restricted.dashboard_transport',
                    title: $translate.instant('dashboard.transport'),
                    allow: 'dashboard_transport__read | dashboard_transport__read_all',
                },
                {
                    link: 'restricted.dashboard_service',
                    title: $translate.instant('dashboard.service'),
                    allow: 'dashboard_service__read | dashboard_service__read_all',
                },
            ],
        },
        {
            id: 9,
            title: $translate.instant('projects'),
            icon: 'build',
            allow: 'projects__read | projects__read_all | projects__write | projects__write_all | phases__read | phases__read_all',
            submenu: [
                {
                    link: 'restricted.projects',
                    title: $translate.instant('projects.list'),
                    allow: 'projects__read | projects__read_all',
                },
                {
                    link: 'restricted.projects_add',
                    title: $translate.instant('projects.add'),
                    allow: 'projects__write | projects__write_all',
                },
                {
                    link: 'restricted.phases',
                    title: $translate.instant('phases.list'),
                    allow: 'projects__read | projects__read_all',
                },
                {
                    link: 'restricted.phases_print',
                    title: $translate.instant('phases.print'),
                    allow: 'projects__read | projects__read_all',
                },
                {
                    link: 'restricted.phases_approval',
                    title: $translate.instant('phases.approvals'),
                    allow: 'projects__phases_approval',
                },
            ],
        },
        {
            id: 6,
            title: $translate.instant('interests'),
            icon: 'grade',
            allow: 'interests__read | interests__read_all | interests__write | interests__write_all',
            submenu: [
                {
                    link: 'restricted.interests',
                    title: $translate.instant('interests.list'),
                    allow: 'interests__read | interests__read_all',
                },
                {
                    link: 'restricted.interests_add',
                    title: $translate.instant('interests.add'),
                    allow: 'interests__write | interests__write_all',
                },
            ],
        },
        {
            id: 7,
            title: $translate.instant('tasks'),
            icon: 'query_builder',
            allow: 'tasks__read | tasks__read_all | tasks__write | tasks__write_all',
            submenu: [
                {
                    link: 'restricted.tasks',
                    title: $translate.instant('tasks.list'),
                    allow: 'tasks__read | tasks__read_all',
                },
                {
                    link: 'restricted.tasks_add',
                    title: $translate.instant('tasks.add'),
                    allow: 'tasks__write | tasks__write_all',
                },
            ],
        },
        {
            id: 5,
            title: $translate.instant('clients'),
            icon: 'people',
            allow: 'clients__read | clients__read_all | clients__write | clients__write_all',
            submenu: [
                {
                    link: 'restricted.clients',
                    title: $translate.instant('clients.list'),
                    allow: 'clients__read | clients__read_all',
                },
                {
                    link: 'restricted.clients_add',
                    title: $translate.instant('clients.add'),
                    allow: 'clients__write | clients__write_all',
                },
                {
                    link: 'restricted.investments',
                    title: $translate.instant('investments'),
                    allow: 'clients__write | clients__write_all',
                },
            ],
        },
        {
            id: 1,
            title: $translate.instant('users'),
            icon: 'face',
            allow: 'users__read | users__manage',
            submenu: [
                {
                    link: 'restricted.users',
                    title: $translate.instant('users.list'),
                    allow: 'users__read',
                },
                {
                    link: 'restricted.users_add',
                    title: $translate.instant('users.add'),
                    allow: 'users__manage',
                } /*,
                     {
                     link: 'restricted.users_mass',
                     title: $translate.instant('users.mass_edit'),
                     allow: 'users__manage'
                     }*/,
            ],
        },
        {
            id: 13,
            title: $translate.instant('areas'),
            icon: 'account_balance',
            allow: 'areas__read | areas__manage',
            submenu: [
                {
                    link: 'restricted.areas',
                    title: $translate.instant('areas.list'),
                    allow: 'areas__read',
                },
                {
                    link: 'restricted.areas_add',
                    title: $translate.instant('areas.add'),
                    allow: 'areas__manage',
                },
            ],
        },
        {
            id: 2,
            title: $translate.instant('groups'),
            icon: 'people',
            allow: 'groups__read | groups__read_all',
            link: 'restricted.groups',
            submenu: [],
        },
        {
            id: 3,
            title: $translate.instant('dictionaries'),
            icon: 'library_books',
            allow: 'dictionaries__read',
            link: 'restricted.dictionaries',
            submenu: [],
        },
        {
            id: 11,
            title: $translate.instant('reports'),
            icon: 'assignment',
            allow: 'reports__read',
            link: 'restricted.reports_period_summary',
            submenu: [],
        },
        {
            id: 12,
            title: $translate.instant('help'),
            icon: 'help',
            allow: 'true',
            link: 'restricted.help',
            submenu: [],
        },
    ];
});
